import React from 'react';
import { Toaster } from 'react-hot-toast';
import { PasswordRecoveryProvider } from './context/PasswordRecoveryContext';
import RecoveryLayout from './components/RecoveryLayout';
import RecoveryForm from './components/RecoveryForm';

export default function PasswordRecoveryPage({ mode = 'request' }) {
  return <PasswordRecoveryProvider key={mode} mode={mode}>
    <Toaster position="top-right" />
    <RecoveryLayout><RecoveryForm /></RecoveryLayout>
  </PasswordRecoveryProvider>;
}
